import { JSX } from 'react'
import { useRecordContext } from 'react-admin'
import PackageGalleryItemList from 'resources/packageGalleryItem/PackageGalleryItemList'

export const ImagesTabContent: () => JSX.Element = () => {
    const record = useRecordContext()
    return <PackageGalleryItemList filter={{ package_id: Number(record?.id) }} />
}
